import { defineStore } from 'pinia';
import { API_URL, authFetch } from '../api';

export const useMonthlyStore = defineStore('monthly', {
  state: () => ({
    summary: null,
    loading: false,
    error: null,
  }),
  actions: {
    async fetchMonthlySummary(year, month) {
      this.loading = true;
      this.error = null;
      try {
        const response = await authFetch(
          `${API_URL}/charts/monthly-summary/?year=${year}&month=${month}`
        );
        this.summary = await response.json();
      } catch (error) {
        this.error = error.message;
        throw error;
      } finally {
        this.loading = false;
      }
    },
  },
});
